module.exports = __webpack_public_path__ + "media/src/assets/images/about_strength-bg-d325544d1137c72886f1b7f938652f1c.jpg";